<template>
  <div id="headTail">
      <div class="row bottom_dv">
          <div class="col-md-6 information">
              <span>联系我们</span>
              <span>上海岐素信息科技有限公司</span>
              <span><i class="iconfont icondizhi"></i> 地址：上海市莘建东路58弄绿地科技岛A座907室</span>
              <!-- <span><i class="iconfont iconyouxiang"></i> 邮箱：service@qisuxinxi.com</span> -->
          </div>
          <div class="col-md-6 QR_codec">
              <!-- <div> -->
                  <img src="../../../static/image/PublicCode.jpg" class="PublicCode_image">
                  <span>微信公众号：汉方颐养</span>
              <!-- </div> -->
              
          </div>
          <div class="col-md-12 QR_code" v-if="slientWidth > 750">
                <span>Copyright © 2016-2019 上海岐素信息科技有限公司.All rights reserved.  <a target="_blank" href="https://beian.miit.gov.cn/">沪ICP备17034514号 </a>   
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202008088"><img src="../../../static/image/ghs.png">沪公网安备 31011202008088号</a>   
            </span>
          </div>

          <div class="col-md-12 QR_code" v-if="slientWidth < 750">
                <span>Copyright © 2016-2019 上海岐素信息科技有限公司.All rights reserved.  <a target="_blank" href="https://beian.miit.gov.cn/">沪ICP备17034514号 </a>
                <br/>
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202008088"><img src="../../../static/image/ghs.png">沪公网安备 31011202008088号</a>
            </span>
          </div>
      </div>
  </div>
</template>

<script>

export default {
    name:'headTail',
    data() {
        return {
            slientWidth:document.body.clientWidth,
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../../../static/css/Overall.css';

</style>



// WEBPACK FOOTER //
// src/components/publicComponent/HeadTail.vue